import React, { useState, ReactNode } from 'react';

import { ResponsiveWrapper } from '../responsiveWrapper/ResponsiveWrapper';
import { ConditionalWrapper } from '../conditionalWrapper/ConditionalWrapper';

import { Chart } from './chart/Chart';
import { Result } from './result/Result';
import { useDimensions } from './utils/useDimensions';
import { Wrapper, Indent, Question, Answer, Description } from './style.DrawIt';
import { IDrawIt, IScore } from './types.DrawIt';

export { IScore as DrawItScore };
export { Result as DrawItResult };

export const DrawIt: React.FC<IDrawIt> = ({ question, answer, description, ...props }) => {
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const { width } = useDimensions();
    const isTablet = width < 1020;

    return (
        <Wrapper>
            <Indent>
                <Question>{question}</Question>
                {description && <Description>{description}</Description>}
            </Indent>
            <ConditionalWrapper condition={isTablet} wrapper={(children: ReactNode) => <Indent>{children}</Indent>}>
                <ResponsiveWrapper heightRatio={isTablet ? 0.67 : 0.5625}>
                    <Chart isComplete={isComplete} setIsComplete={setIsComplete} {...props} />
                </ResponsiveWrapper>
            </ConditionalWrapper>
            <Indent>
                <Answer isVisible={isComplete} dangerouslySetInnerHTML={{ __html: answer }}></Answer>
            </Indent>
        </Wrapper>
    );
};
